export default {_name:'Text.IconText',module:'Field',view:'Element/Text/Icon',options:{md:12}}